import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import Layout from '../../Layout/Layout';
import {
  useTranslator,
  SystemOfMeasuresEnum,
  withLoading,
} from '@front-activerse/common-components';
import TitleBar from '../../Layout/TitleBar';
import MeasurementForm from '../Form/MeasurementForm';
import { saveMeasurementsArgType } from '../types';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';

interface IAddMeasurementContainer {
  saveMeasurements: (formData: saveMeasurementsArgType) => {
    goalLostBecauseOfLoseWeight: boolean;
    goalLostBecauseOfPutOnWeight: boolean;
    goalReachedBecauseOfLoseWeight: boolean;
    goalReachedBecauseOfPutOnWeight: boolean;
    code: number;
  };
  systemOfMeasures: SystemOfMeasuresEnum;
  availableMeasurements: string[][];
}

const AddEditMeasurementContainer: React.FC<IAddMeasurementContainer> = ({
  saveMeasurements,
  systemOfMeasures,
  availableMeasurements,
}) => {
  const { t } = useTranslator();

  return (
    <Layout>
      <TitleBar level={2}>{t('addMeasurements.navbarTitle')}</TitleBar>
      <section className="page-template-measurements full-height3a">
        <Container className="py-md-4">
          <Row>
            <Col md={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="measurements-container">
                  <Row>
                    <Col xl={{ size: 6, offset: 3 }}>
                      <MeasurementForm
                        saveMeasurements={saveMeasurements}
                        systemOfMeasures={systemOfMeasures}
                        availableMeasurements={availableMeasurements}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  );
};

export default withLoading(AddEditMeasurementContainer, UniversalPlaceholder);
